function TurnCup() {
  return (
    <svg className="yatzy-turn-cup" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="4" y="4" width="16" height="16" rx="3.5" stroke="currentColor" strokeWidth="1.7" />
      <circle cx="8.5" cy="8.5" r="1.15" fill="currentColor" />
      <circle cx="15.5" cy="8.5" r="1.15" fill="currentColor" />
      <circle cx="12" cy="12" r="1.15" fill="currentColor" />
      <circle cx="8.5" cy="15.5" r="1.15" fill="currentColor" />
      <circle cx="15.5" cy="15.5" r="1.15" fill="currentColor" />
    </svg>
  )
}

export default TurnCup
